"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
exports.TYPE_TO_BI_CARD_NAME_MAPPING = (_a = {},
    _a[types_1.VIDEO_CARD_TYPES.SOCIAL] = 'get_social_followers',
    _a[types_1.VIDEO_CARD_TYPES.PRODUCT] = 'boost_sales',
    _a[types_1.VIDEO_CARD_TYPES.CUSTOM] = 'custom',
    _a[types_1.VIDEO_CARD_TYPES.VIDEO] = 'promote_video',
    _a[types_1.VIDEO_CARD_TYPES.RECENT_VIDEO] = 'promote_video',
    _a[types_1.VIDEO_CARD_TYPES.CHANNEL] = 'feature_channel',
    _a);
function getBiVideoCardName(_a) {
    var type = _a.type;
    return exports.TYPE_TO_BI_CARD_NAME_MAPPING[type];
}
exports.default = getBiVideoCardName;
//# sourceMappingURL=get-bi-video-card-name.js.map